import {Flex, Typography} from 'antd';
import React from 'react';

import {useScreenInfo} from '../../../ResponsiveGate';
import {SlowSellingProductsWidget} from './components/SlowSellingProductsWidget';

const {Title} = Typography;

export const DashboardPage: React.FC = () => {
    const {screenMap} = useScreenInfo();

    return (
        <Flex
            vertical
            gap={16}
        >
            <Title level={screenMap.lg ? 3 : 5}>Dashboard</Title>
            <SlowSellingProductsWidget />
        </Flex>
    );
};
